import MediaFileType from '@/shared/constants/MediaFileType';
import BaseModel, { ModelID } from '@/shared/models/BaseModel';
import { Url } from '@/shared/models/common';
import EntityType from '../constants/EntityType';
import SubEntityType from '../constants/SubEntityType';
import MediaFileContent from './MediaFileContent';
import MediaData from '@/media/models/MediaData';
import MediaTargetData from '@/general/models/MediaTargetData';
import EditMediaData from '@/media/models/EditMediaData';

export interface MediaFileId2 {__mediaFileId: number}

export default class MediaFile2 extends BaseModel<MediaFileId2> {
  entityType!: EntityType;
  entityId: ModelID | null = null;
  subEntityType: SubEntityType | null = null;
  subEntityId: ModelID | null = null;
  type!: MediaFileType;
  description = '';
  note = '';
  content!: MediaFileContent;
  isLocked = false;
  isWarranty = false;
  isPlaceholder = false;

  static placeholder(url: Url, data: MediaData | EditMediaData, targetData: MediaTargetData): MediaFile2 {
    const file = new MediaFile2();
    file.entityType = targetData.entityType;
    file.entityId = targetData.entityId ?? null;
    file.content = MediaFileContent.placeholder(url);
    file.subEntityType = targetData.subEntityType ?? null;
    file.subEntityId = targetData.subEntityId ?? null;
    file.isLocked = !data.sharedWithClient;
    file.isWarranty = data.isWarranty;
    file.isPlaceholder = true;
    return file;
  }
}